interface XLogoProps extends React.SVGProps<SVGSVGElement> {
  variant?: "hollow" | "solid";
}

export const XLogo: React.FC<XLogoProps> = ({
  variant = "hollow",
  ...props
}) => {
  const hollowPath =
    "M714.163 519.284L1160.89 0H1058.46L667.137 450.887L356.804 0H0L468.356 681.821L0 1226.44H102.432L518.313 747.669L859.596 1226.44H1200L714.137 519.284H714.163ZM572.772 687.828L524.731 619.946L139.965 79.6111H306.615L598.428 496.264L646.469 564.146L1058.49 1150.39H891.84L572.772 687.828Z";
  const solidPath =
    "M714.163 519.284L1160.89 0H1058.46L667.137 450.887L356.804 0H0L468.356 681.821L0 1226.44H102.432L518.313 747.669L859.596 1226.44H1200L714.137 519.284H714.163Z";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="18"
      viewBox="0 0 1200 1227"
      fill="#F7F7F7"
      {...props}
    >
      <title>X Logo</title>
      <path d={variant === "solid" ? solidPath : hollowPath} />
    </svg>
  );
};
